import type {Post} from "~/repository/types";
import {ContentPreferenceValue} from "~/repository/types"

/**
 * Check if user content preferences are met relied on given post
 * @param post
 */
export const useSensitiveContent = (post: Post) => {
    const {user} = useAuthStore()

    /**
     * Show sensitive content overwrite variable
     * Internal variable to overwrite shouldHideSensitiveContent behavior
     */
    const hideSensitiveContent = ref<undefined | false>(undefined)

    /**
     * Check if user should see the "sensitive content" banner.
     * If user content_preferences are set to blur (0) or hide (-1) - then yes
     * If user content_preferences are set to show (1) - then no
     */
    const shouldHideSensitiveContent = computed(() =>
        hideSensitiveContent.value !== undefined ? hideSensitiveContent.value :
            post.content_flags.filter((flag) =>
                user?.settings.content_preferences[flag] === ContentPreferenceValue.BLUR ||
                user?.settings.content_preferences[flag] === ContentPreferenceValue.HIDE
            ).length > 0
    );

    /**
     * Check if user can see the "show sensitive content" button.
     * If user content_preferences are set to hide (-1) - then no
     * If user content_preferences are set to show (1) or blur (0) - then yes
     */
    const canSeeSensitiveContentButton = computed(() =>
        post.content_flags.filter((flag) =>
            user?.settings.content_preferences[flag] !== ContentPreferenceValue.HIDE
        ).length > 0
    )

    /**
     * Show sensitive content
     * Method to attach on button click event
     */
    function showSensitiveContent() {
        hideSensitiveContent.value = false
    }


    return {
        shouldHideSensitiveContent,
        canSeeSensitiveContentButton,
        showSensitiveContent,
    }
}